import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { User } from './User'
import { UserMapper } from './UserMapper'

export class UserCollection {
  protected collection: string = 'user'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  listUsers(): Promise<User[]> {
    const query = this.initQuery()
    return query.list()
  }

  watchUsersByCompanyId(companyId: string): User[] {
    const query = this.initQuery()
    query.setQuery(this.getUsersByCompanyId(query, companyId))

    return query.watchList()
  }

  getUser(id: string): Promise<User | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  async getUserByApiKey(apiKey: string): Promise<User | null> {
    const query = this.initQuery()
    query.setQuery(query.collection(this.collection).where('apiKey', '==', apiKey))
    const users = await query.list()

    return users.length ? users[0] : null
  }

  async getUserByPhone(phoneNumber: string): Promise<User | null> {
    const query = this.initQuery()
    query.setQuery(query.collection(this.collection).where('phoneNumber', '==', phoneNumber))
    const users = await query.list()

    return users.length ? users[0] : null
  }

  async getUserByEmail(email: string): Promise<User | null> {
    const query = this.initQuery()
    query.setQuery(query.collection(this.collection).where('email', '==', email))
    const users = await query.list()

    return users.length ? users[0] : null
  }

  saveUser(user: User): Promise<User> {
    user.name = user.name.trim()

    const query = this.initQuery()
    return query.save(user)
  }

  protected initQuery(): FirestoreQuery<User> {
    const query = new FirestoreQuery<User>(this.db, new UserMapper())
    query.collection(this.collection)

    return query
  }

  protected getUsersByCompanyId(query: FirestoreQuery<User>, companyId: string) {
    return query.collection(this.collection).where('companyId', '==', companyId)
  }
}
